import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import Constants from 'src/core/utils/Constants';
import Translations from 'src/core/utils/Translations';
import { environmentWebUrl } from 'src/core/utils/WebUrls';
import StorageService from 'src/data/services/StorageService';
import { useGlobalStore } from 'src/domain/stores/useGlobalStore';
import { useLeaveAppStore } from 'src/domain/stores/useLeaveAppStore';

const initialState = {
	isOpening: false,
};

export const useReserveStore = create(
	combine({ ...initialState }, (set, get) => {
		// A logout mid-open must not let the stale token reach the website.
		let openingId = 0;

		const reset = () => {
			openingId += 1;
			set({ ...initialState });
		};

		// The website flow reads access_token from its url; without it the member starts as a guest.
		const openStandardReservation = async () => {
			if (get().isOpening) {
				return;
			}

			const currentOpeningId = ++openingId;
			set({ isOpening: true });

			try {
				const url = new URL(useGlobalStore.getState().getGaOriginUrl({ url: environmentWebUrl(Translations.reserveUrl) }));
				const accessToken = await StorageService.getAccessToken();

				if (currentOpeningId !== openingId) {
					return;
				}

				if (accessToken) {
					url.searchParams.set(Constants.paramsAccessToken, accessToken);
				}

				useLeaveAppStore.getState().confirmLeaving({
					url: url.toString(),
					description: Translations.reserveLeaveAppDescription,
				});
			} finally {
				if (currentOpeningId === openingId) {
					set({ isOpening: false });
				}
			}
		};

		return { openStandardReservation, reset };
	}),
);
